/* DON'T EDIT THIS FILE: edit original and run build again */ export const matchfinSupportEmail = "soporte@matchfin.ar";
export const matchfinSupportWhatsapp = "+54 911 3455-0101";
export const matchfinSupportWhatsappUnformatted = "5491134550101";
export const matchfinPaymentsAndSalesEmail = "pagos@matchfin.ar";
